/** @format */

import React from 'react'
import { _$, Button } from '@king-design/react'

interface CloseFooterProps {
  text?: string
  onClose: () => void
}

const CloseFooter: React.FC<CloseFooterProps> = ({ text = _$('关闭'), onClose }) => {
  return (
    <React.Fragment>
      <Button onClick={onClose}>{text}</Button>
    </React.Fragment>
  )
}

export default CloseFooter
